import { render, staticRenderFns } from "./FaqSection.vue?vue&type=template&id=4b05efc2&scoped=true&"
import script from "./FaqSection.vue?vue&type=script&lang=js&"
export * from "./FaqSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b05efc2",
  null
  
)

export default component.exports